import { enqueueSnackbar } from "notistack";

import type { ExportKind } from "./exportTracker";

import { downloadExport } from "@/api/audiences";

export const EXPORT_LINK_TTL_MS = 24 * 60 * 60 * 1000;

export const exportFileName = (name: string) =>
  `${(name || "export").toLowerCase().replace(/\s+/g, "_")}_export.csv`;

export const exportDisplayName = (name: string, kind: ExportKind) =>
  name || (kind === "list" ? "Deleted list" : "Deleted audience");

export const isExportLinkExpired = (updatedAt: string, now = Date.now()) =>
  now - new Date(updatedAt).getTime() > EXPORT_LINK_TTL_MS;

export const startExportDownload = (fileUrl: string, name: string) => {
  downloadExport(fileUrl, exportFileName(name)).catch(() => {
    enqueueSnackbar(
      "Download failed. The link may have expired, export again.",
      {
        variant: "error",
      },
    );
  });
};
